import { SUBDOMAIN } from "constants/auth.constants";

const initialState = {
  loading: false,
  success: null,
  error: null,
  url: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBDOMAIN.REQUEST:
      return {
        ...state,
        loading: true,
        success: null,
        error: null,
      };
    case SUBDOMAIN.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        exists: true,
        ...action.data,
      };
    case SUBDOMAIN.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.data,
      };
    case SUBDOMAIN.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;